import React from 'react';
import { motion } from 'framer-motion';
import { CalendarX, ImageOff, Globe } from 'lucide-react';
const blocks = [{
  icon: CalendarX,
  quote: 'No tengo tiempo para las redes',
  body: 'El día se va atendiendo el local y cuando querés acordar ya es de noche.'
}, {
  icon: ImageOff,
  quote: 'No sé bien qué publicar',
  body: 'Sacás una foto rápida, la subís sin mucho texto y el resultado no convence.'
}, {
  icon: Globe,
  quote: 'Nunca llegué a hacer la página web',
  body: 'Siempre quedó pendiente. Siempre hubo algo más urgente primero.'
}];
export function EnemySection() {
  return <section className="py-20 md:py-32 bg-negro relative overflow-hidden px-5 md:px-8" data-id="element-32">
      <div className="absolute inset-0 bg-noise" data-id="element-33"></div>

      <div className="max-w-[1180px] mx-auto relative z-10" data-id="element-34">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16" data-id="element-35">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-ambar font-nunito text-sm uppercase tracking-[0.1em] font-bold block mb-4" data-id="element-36">
            Por qué todavía no estás online
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-white mb-6 max-w-[800px] mx-auto text-balance leading-tight" data-id="element-37">
            No es que no quisiste.
            <br data-id="element-38" />
            Es que nunca tuviste tiempo.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-arena/65 font-nunito text-lg md:text-xl max-w-[680px] mx-auto leading-relaxed" data-id="element-39">
            Cuando el negocio te consume el día entero, la presencia digital
            siempre queda para después. Y después nunca llega.
          </motion.p>
        </div>

        {/* Body */}
        <div className="max-w-[680px] mx-auto mb-16 md:mb-20 space-y-5 text-arena/70 font-nunito text-lg leading-relaxed" data-id="element-40">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-41">
            No es falta de ganas. Abrís temprano, cerrás tarde. Atendés,
            resolvés, producís. Al final del día no te queda energía para pensar
            en fotos, textos o perfiles.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-42">
            Y así pasan las semanas. El Instagram queda desactualizado. La
            página web nunca se hizo. El TikTok lo abriste una vez y no volviste
            a entrar.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="font-bold text-white" data-id="element-43">
            No porque tu negocio no lo merezca. Sino porque nadie puede hacerlo
            todo solo.
          </motion.p>
        </div>

        {/* Three visual blocks */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 md:mb-20" data-id="element-44">
          {blocks.map((block, index) => {
          const Icon = block.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1 * index
          }} className="bg-arena/[0.06] border border-arena/[0.12] rounded-[14px] p-8 relative overflow-hidden hover:bg-arena/[0.1] transition-colors duration-250 flex flex-col" data-id="element-45">
                <div className="absolute top-0 left-0 right-0 h-[3px] bg-terracota" data-id="element-46"></div>
                <div className="w-14 h-14 rounded-full bg-terracota/15 flex items-center justify-center mb-6" data-id="element-47">
                  <Icon className="text-ambar" size={26} strokeWidth={2} data-id="element-48" />
                </div>
                <p className="font-playfair font-bold text-white text-xl md:text-2xl italic mb-4 leading-snug" data-id="element-49">
                  "{block.quote}"
                </p>
                <p className="font-nunito text-arena/70 text-base leading-relaxed" data-id="element-50">
                  {block.body}
                </p>
              </motion.div>;
        })}
        </div>

        {/* Closing message */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-arena/[0.08] border border-ambar/20 rounded-[16px] p-8 md:p-12 max-w-[860px] mx-auto" data-id="element-51">
          <div className="text-center" data-id="element-52">
            <p className="font-playfair font-bold text-ambar text-2xl md:text-3xl mb-4" data-id="element-53">
              Para eso estamos nosotros.
            </p>
            <p className="font-nunito text-white/85 text-lg md:text-xl leading-relaxed max-w-[640px] mx-auto" data-id="element-54">
              Vos seguís haciendo lo que mejor sabés. Nosotros nos ocupamos de
              que el mundo digital muestre todo lo que construiste.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}